import _get from 'lodash/get';
import axios from 'axios';
import { getCsrfToken } from '../../helpers/twHelper';
import { CONTACT_TOPIC_TREE_INTENTS } from '../../common/storeConstants';
import {
  receivedIDIContactOptionsError,
  requestResponseFromIdi,
  receivedResponseFromIDI,
} from './ContactOptionsAction';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const GET_IDI_CONTACT_CHANNELS_URL = '/smarthelp/api/get-contact-channels';

// Send IDI Post request to IDI server
export const getContactChannelsPostRequest = (kanaCode, topicName) => {
  return axios.post(GET_IDI_CONTACT_CHANNELS_URL, {
    _csrf: getCsrfToken(),
    topicId: kanaCode,
    topicName,
  });
};

// get contact channels from the IDI service
export const getContactChannels = (kanaCode, topicname = '') => {
  return async (dispatch, getState) => {
    dispatch(requestResponseFromIdi());
    // if topic name is empty in params then take from the state
    const topicName = topicname || _get(getState(), `${CONTACT_TOPIC_TREE_INTENTS}.selectedFinalIntent.topic_name`, '');
    const postRequest = getContactChannelsPostRequest(kanaCode, topicName);
    postRequest.then((response) => {
      let IDIChannels = response.data?.channel_availability_decisions || [];
      if (Array.isArray(IDIChannels) && IDIChannels.length > 0) {
        IDIChannels = IDIChannels.map((channel) => {
          channel.priority = channel.rank.toString();
          channel.type = channel.name.toLowerCase();
          return channel;
        });
        dispatch(receivedResponseFromIDI(IDIChannels));
      }
    });
    postRequest.catch(() => dispatch(receivedIDIContactOptionsError()));
  };
};
